<app-common-table
  #cnTable
  [title]="'Quotation'"
  [crumbsMenu]="crumbs"
  [actions]="actions"
  [burgerActions]="burgerActions"
  [columns]="columns"
  [showAddButton]="false"
  (onAddClick)="onAddClick()"
  (onActionClickEmit)="onActionClickEmit($event)"

  (onLoadItemsEvent)="onLoadItemsEvent($event)"
  [showWidthFullWidth]="userCheck.checkUser()"
  [enablePadding]="true"
  [showBreadCrumbs]="true"
  [showFilterBtn]="false"
  [showWidthFullWidth]="false"
  [showActiveArchiveList]="false"
  [programList]="programList"
  (onChangeProgram)="onChangeProgram($event)"
  [showProgramFilter]="showProgramFilter"
  [showSampleTypeFilter]="false"
  [showStatusRouterFilter]="!this.userCheck.checkUser()"
  [routerFilterItems]="badgeFilterItems">
</app-common-table>
